var chunkToChildrenMap = {
	"2231": [
		6067,
		8558
	],
	"2740": [
		6067,
		8558
	],
	"2760": [
		6067,
		8558
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };